/*  MUI  */
import { Alert, AlertTitle, Box, Paper } from '@mui/material';

/*  Integration Component  */
import CustomScript from 'application/Shared/Components/CustomScript/Containers/CustomScript';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const AdminDeploymentScripts = ({ token }) => {
    const { t } = useTranslation();

    return (
        <Paper
            data-testid="adminDeploymentScripts"
            elevation={0}
            variant="outlined"
            sx={{ p: '24px' }}
        >
            <Alert severity="info" icon={false}>
                <AlertTitle style={{ fontWeight: 600 }}>
                    {t('Common.important')}
                </AlertTitle>
                {t('Deployment.client_scripts_warning')}
            </Alert>
            <Box mt="24px">
                <CustomScript clientToken={token} />
            </Box>
        </Paper>
    );
};
